@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.incident-code.label' | translate }}</h2>
	<div class="service-header-buttons">
		<button mat-flat-button color="primary" (click)="toggleShowInactive()">
			{{ 'mes.incident-code.shared.is-active.' + showInactive | translate }}
		</button>
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	<table class="table-responsive" mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.incident-code.shared.alias' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.name }}</td>
		</ng-container>
		<ng-container matColumnDef="group">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.incident-code.shared.group' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.group }}</td>
		</ng-container>
		<ng-container matColumnDef="isActive">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
				{{ 'mes.incident-code.shared.is-active.label' | translate }}
			</th>
			<td mat-cell *matCellDef="let element" style="text-align: center">
				<mat-icon svgIcon="{{ element.isActive ? 'acies_true' : 'acies_false' }}" [ngClass]="element.isActive ? 'greenColor' : 'redColor'"></mat-icon>
			</td>
		</ng-container>

		<ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
			<td mat-cell *matCellDef="let row" style="text-align: end">
				<button mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="openEdit(row.incidentCode)">
						<span>{{ 'mes.incident-code.buttons.editbtn' | translate }}</span>
					</button>
					<button mat-menu-item (click)="onToggleActive(row.incidentCode)">
						<span>
							{{ row.isActive ? ('mes.incident-code.buttons.deactivatebtn' | translate) : ('mes.incident-code.buttons.activatebtn' | translate) }}
						</span>
					</button>
					<button mat-menu-item (click)="openDelete(row.incidentCode)">
						<span>{{ 'mes.incident-code.buttons.deletebtn' | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
